/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

import Axios from '@/lib/axios-instance';

type APIPayload = {
    id: string,
};

type ResponseType = {
    data: any;
    meta: any;
};

export const deleteProactiveChat = async (payload: APIPayload) => {
    try {
        const { id } = payload;
        const response = await Axios.delete(`/pro_active_chats/${id}`);
        return response.data;
    } catch (error: any) {
        if (error.response) {
            throw new Error(
                `${error.response.data?.meta?.message || 'An error occurred'}`,
            );
        }
        throw new Error(error.message || 'Network Error');
    }
};

export const useDeleteProactiveChat = () => {
    const queryClient = useQueryClient();
    return useMutation<ResponseType, Error, APIPayload>({
        mutationFn: (payload) => deleteProactiveChat(payload),
        onSuccess: (data) => {
            toast.success('Proactive Chat Deleted Successfully');
            queryClient.invalidateQueries({ queryKey: ['get_proactive_chats'] });
            console.log(data);
        },
        onError: (error) => {
            toast.error('Deleting Proactive Chat Failed', {
                description: error.message,
            });
        },
    });
};
